import { Elements, PaymentRequestButtonElement } from "@stripe/react-stripe-js";
import { PayPalButton } from "./payment/PayPal";
import { Fragment, useMemo, useEffect, useRef } from "react";
import { ApplePayButton, GooglePayButton } from "./payment/DigitalWallets";

export const ContinueButton = ({
	selectedPaymentMethod,
	paymentMethods,
	setPaymentMethods,
	continueButtonText,
	currentStep,
	steps,
	config,
	onClick,
}) => {
	// Early return if we're on the last step
	if (currentStep === steps.length - 1) {
		return null;
	}

	const formClassname = config?.config?.classname;
	const heartIconFormLocations = ["donation-pod-form", "bar-donation-form"];
	const hasHeartIcon = heartIconFormLocations.includes(formClassname);

	const lottieRef = useRef(null);
	useEffect(() => {
		if (!hasHeartIcon) return;
		if (selectedPaymentMethod?.type !== "button") return;
		if (!lottieRef.current) return;
		if (typeof window.initializeLottie !== "function") return;
	  
		window.initializeLottie(lottieRef.current);
	  }, [hasHeartIcon, selectedPaymentMethod?.type]);

	const baseButton = (
		<button
			className={`next-button btn btn--solid btn--lime ${hasHeartIcon ? "play-lottie" : ""}`}
			type="button"
			onClick={onClick}
		>
			{hasHeartIcon && (
				<div className="donate-lottie" ref={lottieRef}></div>
			)}
			{continueButtonText}
		</button>
	);

	// Check if current step has payment method field
	const hasPaymentMethod = steps[currentStep]?.sections?.some((section) =>
		section.fields?.some((field) => field.slug === "paymentmethod")
	);

	if (!hasPaymentMethod) {
		return baseButton;
	}

	if (selectedPaymentMethod?.loading) {
		return (
			<button
				className="next-button btn btn--solid btn--loading"
				type="button"
				disabled
			>
				Loading...
			</button>
		);
	}

	if (selectedPaymentMethod?.type === "button") {
		return (
			<button
				className={`next-button btn btn--solid btn--lime ${hasHeartIcon ? "play-lottie" : ""}`}
				type="button"
				onClick={onClick}
			>
				{hasHeartIcon && (
					<div className="donate-lottie" ref={lottieRef}></div>
				)}
				{continueButtonText}
			</button>
		);
	}

	switch (selectedPaymentMethod?.triggerType) {
		case "digital_wallet":
			switch (selectedPaymentMethod.digital_wallet_type) {
				case "googlepay":
					return <GooglePayButton onClick={onClick} />;
				case "applepay":
					return <ApplePayButton onClick={onClick} />;
				default:
			}
			break;

		case "paypal":
			return (
				<PayPalButton
					amount={selectedPaymentMethod.amount}
					currency={selectedPaymentMethod.currency}
					clientId={config.paypal_client_id}
					paymentMethods={paymentMethods}
					setPaymentMethods={setPaymentMethods}
				/>
			);

		default:
			return baseButton;
	}
};
